import { Cpu, Gauge, PackageCheck, ShieldCheck } from "lucide-react";
import { siteConfig } from "@/lib/siteConfig";

const reasons = [
  {
    icon: Cpu,
    title: "Mesin Komputer Otomatis",
    desc: "Setiap tusuk dikendalikan komputer, hasilnya seragam dari unit pertama hingga ribuan. Tidak ada hasil 'ngeplos' atau benang loncat.",
  },
  {
    icon: Gauge,
    title: "Produksi Cepat & Paralel",
    desc: "Tiga mesin (12, 6, dan 1 kepala) berjalan bersamaan. Order satuan tetap dapat slot, partai besar tetap on-time.",
  },
  {
    icon: PackageCheck,
    title: "Fleksibel — Tanpa Minimal Order",
    desc: "Mau bordir 1 kemeja untuk hadiah? Bisa. Mau seragam untuk 1.000 karyawan? Juga bisa, dengan harga yang menyesuaikan.",
  },
  {
    icon: ShieldCheck,
    title: "Transaksi Aman via Marketplace",
    desc: "Pembayaran melalui marketplace terpercaya — dana di-hold sampai barang Anda sampai. Resi tracking real-time dikirim ke akun Anda.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="keunggulan"
      data-testid="why-section"
      className="py-20 md:py-28 bg-muted relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
              Mengapa Memilih Kami
            </span>
            <h2
              data-testid="why-headline"
              className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
            >
              Bukan sekadar bordir. Ini standar kerja kami.
            </h2>
            <p className="mt-5 font-body text-base text-muted-foreground leading-relaxed">
              Kami bekerja dengan satu prinsip sederhana: hasil yang Anda terima
              harus bisa dipajang dengan bangga. Itu sebabnya kami berinvestasi
              pada mesin komputer industri dan tim QC yang detail.
            </p>

            <div className="mt-8 rounded-xl overflow-hidden border border-border">
              <img
                src={siteConfig.images.machine}
                alt="Mesin bordir industri dengan banyak benang berwarna"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {reasons.map((r, idx) => (
              <div
                key={idx}
                data-testid={`why-card-${idx}`}
                className="p-7 rounded-xl bg-background border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:border-primary/40"
              >
                <div className="w-11 h-11 rounded-lg bg-secondary flex items-center justify-center mb-5">
                  <r.icon className="w-5 h-5 text-primary" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground">
                  {r.title}
                </h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-muted-foreground">
                  {r.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
